import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { camelToWords } from '@/utils/stringHelper'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import SLAService from './SLA.service'

//TODO: Test
export const useSLA = () => {
  const service = new SLAService()
  const baseCrud = useCrud(API_RESOURCE.SLA, service)

  const queryClient = useQueryClient()

  const useUploadSLAs = () => {
    return useMutation({
      mutationFn: service.uploadSLA(),
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.SLA)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  return {
    //Base CRUD
    useFetchAllSLAs: baseCrud.useFetchAll,
    useFetchSLA: baseCrud.useFetchOne,
    useCreateSLA: baseCrud.useCreate,
    useUpdateSLA: baseCrud.useUpdate,
    useRemoveSLA: baseCrud.useRemove,

    //Extra
    useUploadSLAs,
  }
}
